

import { useEffect } from 'react';
import messages from '../../statics/messages.json'
import { contacts, handleConnectClick } from '../../context/CommonContex';
const ConnectToZoho= ()=>{

    return(
        <div className="box-body border b-white rounded-2">        
        <h4 className="p-2 m-0 border-bottom">Connect to ZOHO(Bigin)</h4>
        <div className="row p-2 d-flex align-item-center justify-content-center">
            <button className='btn btn-primary w-auto' onClick={handleConnectClick}>Connect to Zoho</button>
        </div>
        
        </div>

    )
}

export default ConnectToZoho;